module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-49.e55cf1e9.svg";